import { render, staticRenderFns } from "./OfferFooterCard.vue?vue&type=template&id=d120b4ae&scoped=true"
import script from "./OfferFooterCard.vue?vue&type=script&lang=js"
export * from "./OfferFooterCard.vue?vue&type=script&lang=js"
import style0 from "./OfferFooterCard.vue?vue&type=style&index=0&id=d120b4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d120b4ae",
  null
  
)

export default component.exports